<app-layout [hidden]="!loaded"></app-layout>
<iframe id="printIframe" style="display: none"></iframe>
